import { BaseClient, BaseCommon, BaseServer } from "./namespace/Base";
import { CoopPokerClient, CoopPokerServer } from "./namespace/CoopPoker";
import { PokerClient, PokerServer } from "./namespace/Poker";
import { LobbyClient, LobbyServer } from "./namespace/Lobby";

export const enumify = <K extends string, T extends string>(
  prefix: T,
  vals: readonly K[]
): { [P in K]: `${T}_${P}` } =>
  vals.reduce((p, n) => {
    p[n as K] = `${prefix}_${n}`;
    return p;
  }, {} as { [P in K]: `${T}_${P}` });

export enum AppName {
  LOBBY,
  POKER,
  COOP_POKER,
}

export type GameName = Exclude<AppName, AppName.LOBBY>;
export type Namespace = AppName;

export type ClientMessage =
  | BaseClient.Message
  | LobbyClient.Message
  | PokerClient.Message
  | CoopPokerClient.Message
  | BaseCommon.Message;

export type ClientMessageType = ClientMessage["type"];

export type ServerMessage =
  | BaseServer.Message
  | LobbyServer.Message
  | PokerServer.Message
  | CoopPokerServer.Message
  | BaseCommon.Message;

export type ServerMessageType = ServerMessage["type"];

export type Message = ClientMessage | ServerMessage;
export type MessageType = ClientMessageType | ServerMessageType;
